/* Progressive enhancement of native Shopify GET filtering. No client-only product filtering. */
if (!customElements.get('tm-collection')) {
  customElements.define('tm-collection', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('.tm-catalog-form');
      if (!this.form) return;
      try {
        this.money = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang, { style: 'currency', currency: this.dataset.currency || 'EUR' });
      } catch { this.money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }); }
      this.media = window.matchMedia('(min-width: 750px)');
      this.panel = this.querySelector('.tm-filter-panel');
      const resize = () => { if (this.panel) this.panel.open = this.media.matches; };
      resize();
      this.media.addEventListener('change', resize, options);
      this.querySelectorAll('[data-tm-price]').forEach((group) => {
        group.querySelector('.tm-price-sliders').hidden = false;
        this.syncPrice(group);
      });
      this.addEventListener('input', (event) => {
        const group = event.target.closest('[data-tm-price]');
        if (group) this.syncPrice(group, event.target);
      }, options);
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-tm-sort]')) this.form.requestSubmit();
      }, options);
      this.form.addEventListener('submit', () => {
        // No page input: filtering and sorting always start at page 1.
        this.querySelectorAll('[data-tm-price]').forEach((group) => this.syncPrice(group));
      }, options);
      this.form.addEventListener('formdata', (event) => {
        this.querySelectorAll('[data-price-number]').forEach((input) => {
          if (input.value === '') event.formData.delete(input.name);
        });
      }, options);
      this.dataset.ready = '';
    }
    disconnectedCallback() { this.controller?.abort(); }
    syncPrice(group, changed) {
      const min = group.querySelector('[data-price-number="min"]');
      const max = group.querySelector('[data-price-number="max"]');
      const low = group.querySelector('[data-price-range="min"]');
      const high = group.querySelector('[data-price-range="max"]');
      const bound = Number(high.max);
      let lower = min.value === '' ? 0 : Number(min.value);
      let upper = max.value === '' ? bound : Number(max.value);
      if (changed === low) {
        lower = Math.min(Number(low.value), upper);
        min.value = String(lower);
      } else if (changed === high) {
        upper = Math.max(Number(high.value), lower);
        max.value = String(upper);
      }
      min.setCustomValidity(lower > upper ? this.dataset.priceError : '');
      max.setCustomValidity(lower > upper ? this.dataset.priceError : '');
      low.value = String(Math.max(0, Math.min(bound, lower)));
      high.value = String(Math.max(0, Math.min(bound, upper)));
      low.setAttribute('aria-valuetext', this.money.format(Number(low.value)));
      high.setAttribute('aria-valuetext', this.money.format(Number(high.value)));
      group.querySelector('[data-price-caption]').textContent = `${this.money.format(lower)} – ${this.money.format(upper)}`;
      const track = group.querySelector('.tm-price-sliders');
      track.style.setProperty('--price-low', `${bound ? Number(low.value) / bound * 100 : 0}%`);
      track.style.setProperty('--price-high', `${bound ? Number(high.value) / bound * 100 : 100}%`);
    }
  });
}
